import React from 'react';
import LegacyForm from './LegacyForm';
import Version2025 from './Version2025';

function MaineForm(props) {
  const { version } = props;
  const isVersion2025OrLater = !['11_19', '12_20', '12_22', '12_23'].includes(version);

  // 12_24 onwards
  if (isVersion2025OrLater) return <Version2025 {...props} />;

  return <LegacyForm {...props} />;
}

export default MaineForm;
